import { apiBase } from '../api_client';
import { tokenStore } from './token_store';
import axios from 'axios';

export async function restoreSession() {
    if (tokenStore.has()) {
        return true;
    }

    const BASE = apiBase;
    try {
        const res = await axios.post(
            `${BASE}/api/v1/auth/refresh`,
            {},
            {
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' }
            }
        );
        const token = res.data?.accessToken;
        if (token) {
            tokenStore.set(token);
            return true;
        }
    } catch {
        // Session restore failed - user needs to login
    }
    return false;
}
